import { Address_Schema } from "@/services/addresses/addressSchema";
import type { Address, Address_CreationData, AddressId, AddressType } from "@/services/addresses/addressTypes";
import { ApiClient } from "@/services/apiClient/ApiClient";
import type { AxiosResponse } from "axios";

export const createAddress = async (data: Address_CreationData): Promise<Address> => {
  const url = "api/address/address";
  return ApiClient.post<Address>(url, {}, data).then(({ data }) => Address_Schema.parse(data));
};

export const updateAddress = async (id: AddressId, data: Address_CreationData): Promise<Address> => {
  const url = "api/address/address/" + id;
  return ApiClient.put<Address>(url, {}, data).then(({ data }) => Address_Schema.parse(data));
};

export const deleteAddress = async (id: AddressId): Promise<AxiosResponse> => {
  const url = "api/address/address/" + id;
  return ApiClient.delete(url);
};

type ApiResponse_FetchList = {
  addressList: Address[];
};

export const fetchAddressList = async (type: AddressType): Promise<Address[]> => {
  const url = "api/address/address/";
  return ApiClient.get<ApiResponse_FetchList>(url, { type }).then(({ data }) => Address_Schema.array().parse(data.addressList));
};
